import { z } from "zod";

// Cards travel as 2-char codes: rank + suit. Example: "As", "Td", "9c".
// Ranks: 2-9, T, J, Q, K, A. Suits: s (spades), h (hearts), d (diamonds), c (clubs).

export const RANKS = ["2", "3", "4", "5", "6", "7", "8", "9", "T", "J", "Q", "K", "A"] as const;
export const SUITS = ["s", "h", "d", "c"] as const;

export type RankChar = (typeof RANKS)[number];
export type SuitChar = (typeof SUITS)[number];
export type Card = `${RankChar}${SuitChar}`;

export const CardSchema = z
  .string()
  .regex(/^[2-9TJQKA][shdc]$/)
  .transform((s) => s as Card);

/** Numeric rank: 2..14 (Ace = 14). */
export function rankValue(card: Card): number {
  return RANKS.indexOf(card[0] as RankChar) + 2;
}

export function suitOf(card: Card): SuitChar {
  return card[1] as SuitChar;
}

export function isRed(card: Card): boolean {
  const s = suitOf(card);
  return s === "h" || s === "d";
}

/** Fresh ordered 52-card deck. */
export function fullDeck(): Card[] {
  const deck: Card[] = [];
  for (const s of SUITS) for (const r of RANKS) deck.push(`${r}${s}`);
  return deck;
}
